import { getBrandFocusRing, getDangerFocusRing } from '../focus';
export const button = (theme) => {
    return {
        sizes: {
            xs: {
                height: '20px',
                padding: `0px ${theme.space?.space4}`,
                iconOnlyPadding: '4px',
                fontSize: theme.fontSizes?.xs,
                fontWeight: theme.fontWeights?.[500],
            },
            sm: {
                height: '24px',
                padding: `0px ${theme.space?.space8}`,
                iconOnlyPadding: '4px',
                fontSize: theme.fontSizes?.sm,
                fontWeight: theme.fontWeights?.[500],
            },
            md: {
                height: '32px',
                padding: `0px ${theme.space?.space12}`,
                iconOnlyPadding: '4px',
                fontSize: theme.fontSizes?.md,
                fontWeight: theme.fontWeights?.[500],
            },
            lg: {
                height: '40px',
                padding: `0px ${theme.space?.space16}`,
                iconOnlyPadding: '8px',
                fontSize: theme.fontSizes?.lg,
                fontWeight: theme.fontWeights?.[500],
            },
        },
        variants: {
            primary: {
                backgroundColor: theme.colors?.component?.brand?.default,
                borderWidth: 0,
                color: theme.colors?.text?.basic?.inverse,
                boxShadow: '0',
                '&:hover': {
                    backgroundColor: theme.colors?.component?.brand?.hover,
                },
                '&:active': {
                    backgroundColor: theme.colors?.component?.brand?.active,
                },
                '&:focus-visible': {
                    outline: 'none',
                    backgroundColor: theme.colors?.component?.brand?.default,
                    boxShadow: getBrandFocusRing(theme),
                },
                '&:disabled': {
                    color: theme.colors?.text?.basic?.disabled,
                    backgroundColor: theme.colors?.component?.disabled,
                    cursor: 'not-allowed',
                },
            },
            secondary: {
                backgroundColor: theme.colors?.component?.bold?.default,
                color: theme.colors?.text?.basic?.primary,
                borderWidth: 0,
                boxShadow: '0',
                '&:hover': {
                    backgroundColor: theme.colors?.component?.bold?.hover,
                },
                '&:active': {
                    backgroundColor: theme.colors?.component?.bold?.active,
                },
                '&:focus-visible': {
                    outline: 'none',
                    boxShadow: getBrandFocusRing(theme),
                },
                '&:disabled': {
                    color: theme.colors?.text?.basic?.disabled,
                    backgroundColor: theme.colors?.component?.disabled,
                    cursor: 'not-allowed',
                },
            },
            tertiary: {
                backgroundColor: 'transparent',
                color: theme.colors?.text?.basic?.primary,
                borderWidth: 0,
                boxShadow: '0',
                '&:hover': {
                    backgroundColor: theme.colors?.component?.hover,
                },
                '&:active': {
                    backgroundColor: theme.colors?.component?.active,
                },
                '&:focus-visible': {
                    outline: 'none',
                    boxShadow: getBrandFocusRing(theme),
                },
                '&:disabled': {
                    color: theme.colors?.text?.basic?.disabled,
                    backgroundColor: 'transparent',
                    cursor: 'not-allowed',
                },
            },
            danger: {
                backgroundColor: theme.colors?.component?.negative?.default,
                borderWidth: 0,
                color: theme.colors?.text?.basic?.onColor,
                boxShadow: '0',
                '&:hover': {
                    backgroundColor: theme.colors?.component?.negative?.hover,
                },
                '&:active': {
                    backgroundColor: theme.colors?.component?.negative?.active,
                    border: `none`,
                },
                '&:focus-visible': {
                    outline: 'none',
                    boxShadow: getDangerFocusRing(theme),
                },
                '&:disabled': {
                    color: theme.colors?.text?.basic?.disabled,
                    backgroundColor: theme.colors?.component?.disabled,
                    cursor: 'not-allowed',
                },
            },
            outline: {
                backgroundColor: 'transparent',
                border: `1px solid ${theme.colors?.border?.control}`,
                color: theme.colors?.text?.basic?.primary,
                boxShadow: '0',
                '&:hover': {
                    backgroundColor: theme.colors?.component?.alt?.hover,
                },
                '&:active': {
                    backgroundColor: theme.colors?.component?.brandLight?.active,
                    border: `1px solid transparent`,
                },
                '&:focus-visible': {
                    outline: 'none',
                    boxShadow: getBrandFocusRing(theme),
                },
                '&:disabled': {
                    color: theme.colors?.text?.basic?.disabled,
                    backgroundColor: theme.colors?.component?.disabled,
                    cursor: 'not-allowed',
                },
            },
            isSelected: {
                backgroundColor: theme.colors?.component?.brandLight?.default,
                color: theme.colors?.text?.brand,
                borderWidth: 0,
                boxShadow: '0',
                '&:hover': {
                    backgroundColor: theme.colors?.component?.brandLight?.hover,
                },
                '&:active': {
                    backgroundColor: theme.colors?.component?.brandLight?.active,
                },
                '&:focus-visible': {
                    outline: 'none',
                    boxShadow: getBrandFocusRing(theme),
                },
                '&:disabled': {
                    color: theme.colors?.text?.basic?.disabled,
                    backgroundColor: theme.colors?.component?.disabled,
                    cursor: 'not-allowed',
                },
            },
            nav: {
                backgroundColor: 'transparent',
                color: theme.colors?.foreground?.default,
                borderWidth: 0,
                boxShadow: '0',
                '&:hover': {
                    backgroundColor: theme.colors?.component?.alt?.hover,
                },
                '&:active': {
                    backgroundColor: theme.colors?.component?.brandLight?.active,
                },
                '&:focus-visible': {
                    outline: 'none',
                    backgroundColor: 'transparent',
                    boxShadow: getBrandFocusRing(theme),
                },
                '&:disabled': {
                    color: theme.colors?.foreground?.disabled,
                    backgroundColor: 'transparent',
                    cursor: 'not-allowed',
                },
            },
            ai: {
                backgroundColor: 'transparent',
                color: theme.colors?.text.basic.primary,
                boxShadow: `0 0 0 1px ${theme.colors?.border?.control} inset`,
                '&:hover': {
                    backgroundColor: theme.colors?.component?.alt?.hover,
                },
                '&:active': {
                    backgroundColor: theme.colors?.component?.brandLight?.active,
                },
                '&:focus-visible': {
                    outline: 'none',
                    backgroundColor: 'transparent',
                    boxShadow: getBrandFocusRing(theme),
                },
                '&:disabled': {
                    color: theme.colors?.foreground?.disabled,
                    backgroundColor: 'transparent',
                    cursor: 'not-allowed',
                },
            },
        },
    };
};
//# sourceMappingURL=button.js.map